<template>
  <div class="dialog-wrap">
    <el-dialog title="管理员编辑"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="用户名称"
                      prop="username">
          <el-input v-model="dataForm.username"
                    disabled
                    placeholder="请输入管理员用户名称"></el-input>
        </el-form-item>
        <el-form-item label="昵称"
                      prop="nickname">
          <el-input v-model="dataForm.nickname"
                    placeholder="请输入管理员昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="mobile">
          <el-input v-model="dataForm.mobile"
                    placeholder="请输入管理员手机号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码"
                      prop="password">
          <el-input type="password"
                    v-model="dataForm.password"
                    placeholder="请输入管理员登录密码"></el-input>
        </el-form-item>
        <el-form-item label="选择部门"
                      prop="roles">
          <el-select v-model="dataForm.depts"
                     multiple
                     placeholder="请选择"
                     style="width:340px;">
            <el-option v-for="item in deptoptions"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择角色"
                      prop="roles">
          <el-select v-model="dataForm.roles"
                     multiple
                     placeholder="请选择"
                     style="width:340px;">
            <el-option v-for="item in options"
                       :key="item.id"
                       :label="item.title"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邀请类型"
                      prop="admin_inviter_type"
                      v-if="dataForm.roles.includes(43)">
          <el-select placeholder="请选择"
                     style="width:340px;"
                     v-model="dataForm.admin_inviter_type">
            <el-option v-for="item in typeOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联用户"
                      prop="nickname"
                      v-if="dataForm.admin_inviter_type==2">
          <el-input v-model="dataForm.company_ghost_referrer_uid"
                    placeholder="请输入用户uid"></el-input>
        </el-form-item>
        <el-form-item label="品牌名称"
                      prop="nickname"
                      v-if="dataForm.admin_inviter_type==2">
          <el-input v-model="dataForm.ghost_brand_name"
                    placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="选择专业"
                      prop="roles">
          <div class="choseMajor">
            <el-tag v-for="tag in majors"
                    style="marginTop:5px;marginRight:5px"
                    :key="tag.id"
                    closable
                    type="success"
                    @close="colse(tag)">
              {{tag.name}}
            </el-tag>
            <div style="color:#409eff;cursor: pointer;marginTop:2px;marginLeft:5px"
                 @click="choseMajor()">请选择</div>
          </div>
        </el-form-item>
        <el-form-item label="在线状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
        <el-form-item label="招呼语"
                      prop="default_greet_message ">
          <el-input type="textarea"
                    v-model="dataForm.default_greet_message "
                    placeholder="请输入招呼语"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
  </div>
</template>

<script>
import {
  adminCreate,
  adminRoleList,
  adminUpdate,
  adminPermissions,
  deptlist,
} from '@/api/admin'
import MajorChoose from '@/components/dialog/major/MajorChoose'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: { MajorChoose },
  data() {
    return {
      dialogVisible: this.visible,
      majorChooseDialog: false,
      majors: [],
      dataForm: this.content || {},
      rules: {
        nickname: [
          { required: false, message: '请输入管理员昵称', trigger: 'blur' },
        ],
        mobile: [
          {
            required: true,
            message: '请输入管理员手机号',
            trigger: 'blur',
            pattern: /^[0-9]{11}$/,
          },
        ],
        password: [
          {
            required: false,
            message: '请输入管理员登录密码',
            trigger: 'blur',
            min: 6,
          },
        ],
        status: [
          { required: false, message: '请设置在线状态', trigger: 'change' },
        ],
      },
      options: [],
      deptoptions: [],
      typeOptions: [
        {
          label: '普通渠道邀请人',
          value: 1,
        },
        {
          label: '小程序渠道邀请人',
          value: 2,
        },
      ],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.fetchAdminRoleList()
      this.fetchAdminDeptList()
      if (val) {
        this.dataForm = val
        if (val.roles.length > 0) {
          this.dataForm.roles = val.roles.split(',').map((v) => Number(v))
        } else {
          this.dataForm.roles = []
        }
        if (val.depts.length > 0) {
          this.dataForm.depts = val.depts.split(',').map((v) => Number(v))
        } else {
          this.dataForm.depts = []
        }
        if (val.admin_major_rows.length > 0) {
          val.admin_major_rows.map((item) => {
            this.majors.push({
              code: item.major_code,
              name: item.major_name,
              college_code: item.college_code,
            })
          })
          console.log('admin_major_rows', val.admin_major_rows)
        }
      }
    },
  },
  methods: {
    saveMajor({ majors }) {
      this.majors = majors
    },
    choseMajor() {
      this.majorChooseDialog = true
    },
    colse(val) {
      this.majors = this.majors.filter((v) => {
        return v.code != val.code
      })
    },
    fetchAdminRoleList() {
      adminRoleList({ isPaing: 0 }).then((res) => {
        this.options = res.list
      })
    },
    fetchAdminDeptList() {
      deptlist({ isPaing: 0 }).then((res) => {
        this.deptoptions = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let admin_major_rows = []
          this.majors.map((item) => {
            admin_major_rows.push({
              major_code: item.code,
              major_name: item.name,
              college_code: item.college_code,
            })
          })
          const params = {
            id: this.dataForm.id,
            nickname: this.dataForm.nickname,
            password: this.dataForm.password,
            mobile: this.dataForm.mobile,
            status: this.dataForm.status ? 1 : 0,
            depts: this.dataForm.depts.join(',') || '',
            roles: this.dataForm.roles.join(',') || '',
            default_greet_message: this.dataForm.default_greet_message,
            admin_major_rows: admin_major_rows,
          }
          if (this.dataForm.roles.includes(43)) {
            params.admin_inviter_type = this.dataForm.admin_inviter_type
            if (this.dataForm.admin_inviter_type == 2) {
              params.company_ghost_referrer_uid =
                this.dataForm.company_ghost_referrer_uid
              params.ghost_brand_name = this.dataForm.ghost_brand_name
            }
          }
          adminUpdate(params)
            .then((res) => {
              this.$message.success(`修改成功`)
              this.$refs['dataForm'].resetFields()
              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
      this.majors = []
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
    .choseMajor {
      display: flex;
      flex-flow: row wrap;
    }
  }
}
</style>
